import React, { useEffect } from 'react';
import getLogger from '@ignitesales/logger-es';
import classNames from 'classnames';
import { ProductPagePropTypes } from '../../utils';
import {
  completeRemoteSession,
  useDispatch
} from '../../state';

const logger = getLogger({ component: 'ErrorBoundary' });

const RemoteSummaryPage = (props) => {
  logger.debug('Remote summary page props', props);
  const appDispatch = useDispatch();
  const { componentClass: defaultComponentClasses } = props;
  const classes = classNames('remoteSummaryPage', defaultComponentClasses);

  useEffect(() => {
    appDispatch(completeRemoteSession());
  }, []);

  return (
    <div className={classes}>
      <h1>Need to implement the Remote Summary Page content</h1>
    </div>
  );
};
RemoteSummaryPage.propTypes = ProductPagePropTypes;

export default RemoteSummaryPage;
